export default [
  {
    title: 'داشبورد',
    route: 'home',
    icon: 'HomeIcon',
  },
  {
    title: 'صورتحساب',
    route: 'accountSummaries',
    icon: 'ShoppingCartIcon',
  },
  {
    title: 'تراکنش‌ها',
    route: 'accountDetails',
    icon: 'CheckSquareIcon',
  },
  {
    title: 'هزینه‌های ساختمان',
    route: 'accountExpenses',
    icon: 'CreditCardIcon',
  },
  {
    title: 'پروفایل',
    route: 'userProfile',
    icon: 'UserIcon',
  },
  {
    title: 'خروج',
    route: 'logout',
    icon: 'LogOutIcon',
  },
]
